import { CptView } from './types/contractTypes';

export const createDefaultCpt = (feeScheduleId: string = ''): CptView => {
  return {
    id: '',
    feeScheduleId,
    code: '',
    name: '',
    category: '',
    apcCode: '',
    baseRate: 0,
    grouperPointer: '',
    multiProcedureDiscount: false,
    relativeWeight: null,
  };
};
